import { createFileRoute } from '@tanstack/react-router';

import { ToolFrame } from '../app/tool-frame.js';
import { ProvincialSection } from '../features/projects/detail/provincial/provincial-section.js';

export const Route = createFileRoute(
  '/_authed/teams/$teamId/projects/$projectId/provincial',
)({
  component: () => (
    <ToolFrame toolSlug="provincial" Section={ProvincialSection} requiresReport />
  ),
});
